import React, { useEffect, useRef, useState } from 'react';
import styles from '../schedule.module.css';

const Card = ({ card, index, onSelectGame }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [needsToggle, setNeedsToggle] = useState(false);
    const [maxLines, setMaxLines] = useState(12);
    const textRef = useRef(null);

    useEffect(() => {
        const el = textRef.current;
        if (!el) return;

        const limit = (() => {
            if (window.matchMedia('(max-width: 767px)').matches) return 6;
            if (window.matchMedia('(max-width: 1900px)').matches) return 8;
            return 12;
        })();

        setMaxLines(limit);

        // 👉 Добавляем классы clamp ОДИН РАЗ, сразу
        el.classList.add(styles.clamped, styles[`clamped--${limit}`]);

        const update = () => {
            // ❗️ Никаких classList здесь — только измерения!
            const isClamped = el.scrollHeight > el.clientHeight + 1;
            setNeedsToggle(isClamped);
        };

        // Выполняем начальное измерение
        update();

        // Подключаем наблюдатель
        const ro = new ResizeObserver(() => {
            requestAnimationFrame(update); // 💡 отложено на следующий кадр, безопасно
        });

        ro.observe(el);
        window.addEventListener('resize', update);

        return () => {
            ro.disconnect();
            window.removeEventListener('resize', update);
        };
    }, [card.catalogCard.description]);


    const toggleExpand = () => setIsExpanded(prev => !prev);

    const formattedDate = new Date(card.startedAt).toLocaleDateString('ru-RU');
    const formattedTime = new Date(card.startedAt).toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit'
    });

    const isEven = index % 2 === 0;

    const pluralHours = h => {
        const d = h % 10,
            dd = h % 100;
        if (dd >= 11 && dd <= 14) return 'часов';
        if (d === 1) return 'час';
        if (d >= 2 && d <= 4) return 'часа';
        return 'часов';
    };

    const info = [
        {
            label: 'Система',
            value: `${card.catalogCard.gameSystemName} | ${card.catalogCard.sessionFormatName}`
        },
        { label: 'Мастер', value: card.masterName },
        {
            label: 'Продолжительность',
            value: card.maxDurationHours
                ? `${card.minDurationHours} – ${card.maxDurationHours} ${pluralHours(
                    card.maxDurationHours
                )}`
                : `${card.minDurationHours} ${pluralHours(card.minDurationHours)}`
        },
        {
            label: 'Стоимость',
            value: card.catalogCard.cost
            ? (
                card.isDiscount
                    ? `${card.catalogCard.cost - (card.catalogCard.cost * card.discount / 100)} ₽`
                    : `${card.catalogCard.cost} ₽`
                )
            : 'Не указана'
        },
        {
            label: 'Осталось мест',
            value: `${card.freeCountPlayers} из ${card.maxCountPlayers}`
        }
    ];

    const renderInfoRow = (label, value) => (
        <div
            className={`col-12 d-flex justify-content-between ${styles.infoLine}`}
            key={label}
        >
            <p className={`col-auto body ${styles.label}`}>{label}</p>
            <p className="col-auto body text-end">{value}</p>
        </div>
    );

    return (
        <div className={`${styles.scheduleCard} ${isEven ? '' : styles.evenCard}`}>
            <div className="container-custom my-0">
                <div className={`${styles.cardWrapper} row`}>
                    {/* дата / время */}
                    <div className="col-md-12 mb-md-3 col-lg-3">
                        <h2>{formattedDate}</h2>
                        <p className={`body ${styles.time}`}>{formattedTime}</p>
                    </div>

                    {/* картинка */}
                    <div className={`col-md-4 col-lg-3 ${styles.imgWrapper}`}>
                        { card.isDiscount && (
                            <img className={styles.discountImage} src="/images/discountGame.png" alt=""/>
                        )}
                        <img
                            className={styles.scheduleImg}
                            src={card.catalogCard.imageUrl || '/images/plug.avif'}
                            alt={`Картинка игры ${card.catalogCard.title}`}
                        />
                    </div>

                    {/* описание */}
                    <div className="col-md-4 col-lg-3 d-flex flex-column">
                        <h3 className={styles.cardTitle}>{card.catalogCard.title}</h3>

                        <div
                            ref={textRef}
                            className={`${styles.descriptionWrapper} ${
                                !isExpanded
                                    ? `${styles.clamped} ${styles[`clamped--${maxLines}`]}`
                                    : ''
                            }`}
                        >
                            <p className={`${styles.descriptionText} body`}>
                                {card.catalogCard.description}
                                {!isExpanded && needsToggle && (
                                    <span className={styles.readMore} onClick={toggleExpand}>
                                        <span className={styles.dots}>…</span> Далее
                                    </span>
                                )}
                            </p>

                            {isExpanded && (
                                <span className={styles.readMore} onClick={toggleExpand}>
                                  Скрыть
                                </span>
                            )}
                        </div>
                    </div>

                    {/* инфо и кнопка */}
                    <div className="col-md-4 col-lg-3 d-flex flex-column justify-content-between">
                        <div>{info.map(item => renderInfoRow(item.label, item.value))}</div>

                        <button
                            disabled={!card.isButtonActive}
                            className={`${styles.btnCard} btn btn-brown-noLine w-100`}
                            onClick={() => card.isButtonActive && onSelectGame(card.id)}
                        >
                            <p>{card.isButtonActive ? 'Записаться' : 'Мест нет'}</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Card;
